<template>
  <div class="page-container">
    <div class="page-title-container">
      <h1 class="page-title">
        {{ editing ? "Editar marca" : "Nueva marca" }}
      </h1>
    </div>
    <div>
      <form class="custom-form" @submit.prevent="save" novalidate>
        <b-card
          tag="article"
          no-body
          style="max-width: 760px"
          class="custom-card"
        >
          <b-card-header
            header-tag="section"
            class="custom-card-header d-flex align-items-center"
          >
            <h3>
              {{ editing ? "Datos de la marca" : "Datos de la nueva marca" }}
            </h3>
          </b-card-header>
          <b-card-body class="custom-card-body p-0">
            <section class="form-section">
              <div class="custom-form-row custom-form-row--col-2">
                <div class="form-group">
                  <label for="identifier">R.U.C. *</label>
                  <input
                    id="identifier"
                    type="text"
                    maxlength="11"
                    v-model.trim="form.identifier"
                    autocomplete="off"
                    placeholder="Ingresar número de RUC"
                    class="custom-form-control"
                    :class="{
                      'custom-form-control-error': $v.form.identifier.$error,
                    }"
                  />
                  <FormError
                    v-if="
                      $v.form.identifier.$error && !$v.form.identifier.required
                    "
                    message="RUC es requerido"
                  />
                  <FormError
                    v-if="
                      $v.form.identifier.$error && !$v.form.identifier.numeric
                    "
                    message="RUC debe tener un valor numérico"
                  />
                  <FormError
                    v-if="
                      $v.form.identifier.$error && !$v.form.identifier.minLength
                    "
                    message="RUC debe tener 11 dígitos"
                  />
                </div>

                <div class="form-group">
                  <label for="name">Razón social *</label>
                  <input
                    id="name"
                    type="text"
                    maxlength="200"
                    v-model="form.name"
                    autocomplete="off"
                    placeholder="Ingresar razón social"
                    class="custom-form-control"
                    :class="{
                      'custom-form-control-error': $v.form.name.$error,
                    }"
                  />
                  <FormError
                    v-if="$v.form.name.$error && !$v.form.name.required"
                    message="Razón social es requerida"
                  />
                </div>
              </div>

              <div class="form-group">
                <label for="address">Dirección fiscal *</label>
                <input
                  id="address"
                  type="text"
                  v-model="form.address"
                  autocomplete="off"
                  placeholder="Ingresar domicilio fiscal"
                  class="custom-form-control"
                />

                <FormError
                  v-if="$v.form.address.$error && !$v.form.address.required"
                  message="Dirección fiscal es requerida"
                />
              </div>

              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="tradeName">Nombre comercial</label>
                    <input
                      id="tradeName"
                      type="text"
                      v-model="form.tradeName"
                      autocomplete="off"
                      placeholder="Nombre de contacto"
                      class="custom-form-control"
                    />

                    <FormError
                      v-if="
                        $v.form.tradeName.$error && !$v.form.tradeName.required
                      "
                      message="Nombre comercial es requerido"
                    />
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group">
                    <label for="contact">Persona de contacto</label>
                    <input
                      id="contact"
                      type="text"
                      v-model="form.contact"
                      autocomplete="off"
                      placeholder="Nombre de contacto"
                      class="custom-form-control"
                    />
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="mobile">Celular</label>
                    <input
                      id="mobile"
                      type="text"
                      v-model.trim="form.mobile"
                      autocomplete="off"
                      placeholder="Ingresar celular"
                      maxlength="9"
                      class="custom-form-control"
                      :class="{
                        'custom-form-control-error': $v.form.mobile.$error,
                      }"
                    />
                    <FormError
                      v-if="$v.form.mobile.$error && !$v.form.mobile.numeric"
                      message="Celular debe ser un valor numérico"
                    />
                    <FormError
                      message="Ingresa un celular válido de 9 dígitos"
                      v-if="$v.form.mobile.$error && !$v.form.mobile.mobile"
                    ></FormError>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group">
                    <label for="email">Correo electrónico</label>
                    <input
                      id="email"
                      type="text"
                      v-model.trim="form.email"
                      autocomplete="off"
                      placeholder="Ingresar correo electrónico"
                      class="custom-form-control"
                      :class="{
                        'custom-form-control-error': $v.form.email.$error,
                      }"
                    />
                    <FormError
                      v-if="$v.form.email.$error && !$v.form.email.email"
                      message="Ingresa un correo electrónico válido"
                    />
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <div class="form-group mb-0">
                    <label for="website">Página web *</label>
                    <input
                      id="website"
                      type="text"
                      v-model.trim="form.website"
                      autocomplete="off"
                      placeholder="Ingresar página web"
                      class="custom-form-control"
                    />
                  </div>
                </div>
              </div>

              <div class="form-group-buttons text-right">
                <router-link
                  :to="{ name: 'brands-list' }"
                  class="button button-light"
                >
                  {{ editing ? "Volver" : "Cancelar" }}
                </router-link>
                <button class="button button-primary" type="submit">
                  Guardar
                </button>
              </div>
            </section>
          </b-card-body>
        </b-card>
      </form>
    </div>
  </div>
</template>

<script>
import { Alert, CustomValidators, FormError, Constants } from "wize-admin";
import  { Helpers } from "@/core/utils";

import { BrandService } from "@/core/services";
// import { Constants as LocalConstants } from "@/core/utils";
import { email, minLength, numeric, required } from "vuelidate/lib/validators";

export default {
  components: {
    FormError,
  },
  data() {
    return {
      identifierTypes: [
        Constants.IdentifierType.DNI,
        Constants.IdentifierType.RUC,
        Constants.IdentifierType.CE,
        Constants.IdentifierType.PASAPORTE,
      ],
      form: {
        identifier: null,
        name: null,
        tradeName: null,
        address: null,
        contact: null,
        mobile: null,
        email: null,
        website: null
      },
      editing: false,
    };
  },
  validations: {
    form: {
      identifier: { required, numeric, minLength: minLength(11) },
      name: { required },
      tradeName: { required },
      address: { required },
      mobile: { numeric, mobile: CustomValidators.mobile },
      email: { email },
      website: { required },
    },
  },
  watch: {
    "$route.params.id": function () {
      if (this.$route.params.id) this.load(this.$route.params.id);
    },
  },
  computed: {},
  methods: {
    async save() {
      this.$v.$touch();
      if (this.$v.$error) {
        this.$nextTick(() => {
          this.$smoothScroll({
            scrollTo: document.querySelector(".form-error"),
            updateHistory: false,
            offset: -50,
          });
        });

        return;
      }

      try {
        this.$store.dispatch("app/loading", true);

        const data = { ...this.form, slug: Helpers.sluglify(this.form.tradeName) };

        if (!this.editing) await BrandService.save(data);
        else await BrandService.update(this.$route.params.id, data);
        Alert.success("Se almacenó la información correctamente");
        this.load(this.$route.params.id);
        if (!this.editing) {
          this.$router.push({
            name: "brands-list"
          });
          this.editing = true;
        }
      } catch (ex) {
        console.error(ex);
        Alert.error(ex.errors.message);
      } finally {
        this.$store.dispatch("app/loading", false);
      }
    },
    async load(id) {
      try {
        this.$store.dispatch("app/loading", true);
        const response = await BrandService.get(id);
        const payload = response.payload;

        this.form = {
          ...payload,
        };

        this.editing = true;
      } catch (e) {
        console.error(e);
        Alert.error(e.errors.message);
        this.$router.push({ name: "form-list" });
      } finally {
        this.$store.dispatch("app/loading", false);
      }
    },
  },
  async created() {
    if (this.$route.params.id) this.load(this.$route.params.id);
  },
};
</script>

<style lang="stylus" scoped></style>
